module.exports = __webpack_public_path__ + "static/img/5.cf86ca1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/eng/5.png
// module id = Fwfu
// module chunks = 0